import * as React from "react";

import { WorkspaceSidebarContext } from "./context";
import { WorkspaceSidebarStorage } from "./sidebarStorage";
import { SidebarTab, SidebarView, SidebarViewType } from "./sidebarView";

export function WorkspaceSidebarProvider({
  children,
}: React.PropsWithChildren) {
  // Initialize activeView from localStorage
  const [activeView, setActiveView] = React.useState<SidebarView<unknown>>(
    () => {
      const stored = WorkspaceSidebarStorage.getActiveView();
      return {
        type: stored?.type ?? SidebarViewType.TabbedSidebar,
        data: undefined,
      };
    },
  );

  const [activeDrawer, setActiveDrawer] =
    React.useState<SidebarView<unknown> | null>(null);

  // Initialize activeTab from localStorage
  const [activeTab, setActiveTab] = React.useState<SidebarTab>(() => {
    const stored = WorkspaceSidebarStorage.getActiveView();
    return stored?.tab ?? SidebarTab.Files;
  });

  const close = () => {
    setActiveView({
      type: SidebarViewType.None,
      data: undefined,
    });
  };

  // Persist activeView and activeTab to localStorage
  React.useEffect(() => {
    WorkspaceSidebarStorage.setActiveView(
      activeView.type,
      activeView.type === SidebarViewType.TabbedSidebar ? activeTab : undefined,
    );
  }, [activeView.type, activeTab]);

  return (
    <WorkspaceSidebarContext.Provider
      value={{
        activeView,
        activeDrawer,
        close,
        openView: setActiveView,
        toggleDrawer: setActiveDrawer,
        activeTab: activeTab,
        setActiveTab: setActiveTab,
      }}
    >
      {children}
    </WorkspaceSidebarContext.Provider>
  );
}
